import script from "./AnnotationSetInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotationSetInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./AnnotationSetInfoModal.vue?vue&type=style&index=0&id=ba0113de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba0113de"]])

export default __exports__